import api from "./axios";

export interface CheckoutResponse {
  checkout_url: string;
  checkout_id: string;
  plan_cycle: "monthly" | "yearly";
}

export interface CreateCheckoutRequest {
  plan_cycle: "monthly" | "yearly";
  plan_type: "pro";
}

export interface BillingPortalResponse {
  portal_url: string;
  subscription_status: string;
  plan_type: string;
  expires_at: string;
  message: string;
}

export interface CancelSubscriptionRequest {
  cancellation_reason: string;
  cancellation_comment?: string;
}

export interface CancelSubscriptionResponse {
  message: string;
  subscription: {
    plan_type: string;
    plan_cycle: string;
    is_subscribed: boolean;
    is_active: boolean;
    subscription_status: string;
    started_at: string;
    expires_at: string;
    expires_in_days: number;
  };
}

export const planApi = {
  createCheckout: async (
    data: CreateCheckoutRequest
  ): Promise<CheckoutResponse> => {
    const response = await api.post<CheckoutResponse>(
      "/api/subscription/checkout",
      data
    );
    return response.data;
  },

  getBillingPortal: async (): Promise<BillingPortalResponse> => {
    const response = await api.get<BillingPortalResponse>(
      "/api/subscription/portal"
    );
    return response.data;
  },

  cancelSubscription: async (
    data: CancelSubscriptionRequest
  ): Promise<CancelSubscriptionResponse> => {
    const response = await api.post<CancelSubscriptionResponse>(
      "/api/subscription/cancel",
      data
    );
    return response.data;
  },
};
